import { useState, createContext } from 'react';

import { IntlProvider } from 'react-intl';

import messagesPt from 'assets/locales/pt.json';

const menuMessages = {
  pt: { ...messagesPt },
};

const Context = createContext();

const IntlProviderWrapper = ({ children }) => {
  const [locale, setLocale] = useState('pt');
  const [messages, setMessages] = useState(menuMessages['pt']);

  const switchLanguage = (lang) => {
    setLocale(lang);
    setMessages(menuMessages[lang]);
  };

  return (
    <Context.Provider value={{ locale, switchLanguage }}>
      <IntlProvider
        key={locale}
        locale={locale}
        messages={messages}
        defaultMessage={'Teste'}
        defaultLocale='pt'
        onError={() => {}}
      >
        {children}
      </IntlProvider>
    </Context.Provider>
  );
};

export { IntlProviderWrapper, Context as IntlContext };
